export type TablePreviewSource =
  | { rows: ReadonlyArray<readonly string[]> }
  | { table: { headers: readonly string[]; rows: ReadonlyArray<Readonly<Record<string, string>>> } }

export function tablePreviewPage(source: TablePreviewSource, requestedPage = 0, requestedSize = 100) {
  const headers = "table" in source ? source.table.headers : source.rows[0] ?? []
  const total = "table" in source ? source.table.rows.length : Math.max(0, source.rows.length - 1)
  const size = Number.isFinite(requestedSize) && requestedSize > 0 ? Math.min(250, Math.max(1, Math.trunc(requestedSize))) : 100
  const pages = Math.max(1, Math.ceil(total / size))
  const page = Number.isFinite(requestedPage) ? Math.max(0, Math.min(pages - 1, Math.trunc(requestedPage))) : 0
  const offset = page * size
  // Read and format only the visible page, not the full extracted dataset.
  const rows = Array.from({ length: Math.min(size, total - offset) }, (_, index) =>
    headers.map((header, column) => "table" in source
      ? source.table.rows[offset + index]?.[header] ?? ""
      : source.rows[offset + index + 1]?.[column] ?? ""),
  )
  return { headers, rows, total, pages, page, offset, start: total ? offset + 1 : 0, end: offset + rows.length }
}

export function declaredExtractionTableCount(value: unknown) {
  if (!Array.isArray(value)) return undefined
  const count = value.filter((item) => {
    if (!isObject(item)) return false
    const rows = item.rows ?? item.data ?? item.values
    if (!Array.isArray(rows)) return false
    if (Array.isArray(item.rows) && item.rows.length === 0 && Array.isArray(item.columns) && item.columns.some((column) => typeof column === "string")) return true
    return rows.some((row) => isObject(row) && Object.keys(row).length > 0)
  }).length
  // Unknown legacy shapes still use the existing parser's fallback rules.
  return count || undefined
}

function isObject(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === "object" && !Array.isArray(value)
}
